export default "__VITE_ASSET__289c25a3__"